export const SET_CHAT_UNREAD = (state, count) => {
  state.chatUnread = count;
};

export const setTooltipObj = (state, payload) => {
  state.tooltipObject = payload;
};

export const setShowVikiMsg = (state, payload) => {
  state.showVikiMsg.show = payload.show;
  state.showVikiMsg.id = payload.id;
  state.showVikiMsg.msg = payload.msg;
  state.showVikiMsg.type = payload.type;
  state.showVikiMsg.op = payload.op;
  state.showVikiMsg.op_code = payload.op_code;
  state.showVikiMsg.cond = payload.cond;
  state.showVikiMsg.updatedAt = payload.updatedAt;
  if (payload.hasOwnProperty("sub_cond")) {
    state.showVikiMsg.sub_cond = payload.sub_cond;
  }
  if (payload.hasOwnProperty("options")) {
    state.showVikiMsg.options = payload.options;
  }
};
